module.exports = __webpack_public_path__ + "media/punch.0b6f9db4.mp3";